module.exports = __webpack_public_path__ + "static/img/aboutBg.a5d6a6d4.png";